import { takeEvery, takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
    getProfessionalsError,
    getProfessionalsSuccessful,
    removeProfessionalError,
    removeProfessionalSuccess,
    getProfessionals,
    editProfessionalError,
    editProfessionalSuccess,
    approveProfessionalSuccess,
    approveProfessionalError, 
    updateProfessionalTranslationsSuccess, 
    updateProfessionalTranslationsError,
    setProfessionalQuery
} from "./actions";
import ProfessionalService from "./service";
import { ProfessionalActionTypes } from "./actionTypes";
import { mergeListQuery } from "helpers/listQuery";

// Selector to get the professional query state from the Redux store.
export const getProfessionalQuery = state => state.Professional.query;

export function* get({ payload }) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getProfessionalQuery);
        // The payload overrides the stored query; a different role tab starts
        // on page 1 with no search term (every role shares this query).
        const finalPayload = mergeListQuery(storedQuery, payload, 'type');
        const response = yield call(ProfessionalService.getProfessionals, finalPayload);
        yield put(getProfessionalsSuccessful(response));
        yield put(setProfessionalQuery(finalPayload));
    } catch (error) {
        yield put(getProfessionalsError(error));
    }
}

export function* removeProfessional({ payload: professionalId, type }) {
    try {
        const response = yield call(ProfessionalService.removeProfessional, professionalId);
        yield put(removeProfessionalSuccess(response));
        yield put(getProfessionals({ type }));
    } catch (error) {
        yield put(removeProfessionalError(error));
    }
}

export function* edit({ payload: professional }) {
    try {
        const response = yield call(ProfessionalService.editProfessional, professional);
        yield put(editProfessionalSuccess(response));
        yield put(getProfessionals({ type: professional.role }));
    } catch (error) {
        yield put(editProfessionalError(error));
    }
}

export function* editTranslation({ payload: professional }) {
    try {
        const response = yield call(ProfessionalService.updateTranslationsProfessional, professional);
        yield put(updateProfessionalTranslationsSuccess(response));
        yield put(getProfessionals({ type: professional.role }));
    } catch (error) {
        yield put(updateProfessionalTranslationsError(error));
    }
}

export function* approve({ payload: professional }) {
    try {
        console.log(professional)
        const response = yield call(ProfessionalService.approveProfessional, professional);
        yield put(approveProfessionalSuccess(response));
        yield put(getProfessionals({ type: professional.role }));
    } catch (error) {
        yield put(approveProfessionalError(error));
    }
}

export function* watchGetProfessional() {
    yield takeLatest(ProfessionalActionTypes.PROFESSIONAL_LIST_GET, get);
}

export function* watchRemoveProfessional() {
    yield takeEvery(ProfessionalActionTypes.PROFESSIONAL_REMOVE, removeProfessional);
}

export function* watchEditProfessional() {
    yield takeEvery(ProfessionalActionTypes.PROFESSIONAL_EDIT, edit);
}

export function* watchEditTranslationsProfessional() {
    yield takeEvery(ProfessionalActionTypes.PROFESSIONAL_TRANSLATION_EDIT, editTranslation);
}

export function* watchApproveProfessional() {
    yield takeEvery(ProfessionalActionTypes.PROFESSIONAL_APPROVE, approve);
}

function* professionalsSaga() {
    yield all([
        fork(watchGetProfessional),
        fork(watchRemoveProfessional),
        fork(watchEditProfessional),
        fork(watchEditTranslationsProfessional),
        fork(watchApproveProfessional)
    ]);
}

export default professionalsSaga;
